export default __webpack_public_path__ + "static/media/Icon feather-search.5f306b8c.svg";